import { Menu } from "react-feather";
import { LI, UL } from "../../../../AbstractElements";
import { Href } from "../../../../Constant";
import { CHAT_MENU_ICONS } from "../../../../Data/Chat";
import { useAppDispatch } from "../../../../Redux-Toolkit/Hooks";
import { setToggleSideBar } from "../../../../Redux-Toolkit/Reducers/ChatSlice";

const ChatMenuIcons = () => {
  const dispatch = useAppDispatch();
  const chatMenuIconsHandler = () => dispatch(setToggleSideBar());

  return (
    <UL className="list-inline float-start float-sm-end chat-menu-icons simple-list d-flex flex-row">
      {CHAT_MENU_ICONS.map((item, index) => (
        <LI className="list-inline-item" key={index}><a href={Href}><i className={`icon-${item}`}></i></a></LI>
      ))}
      <LI className="list-inline-item toogle-bar" onClick={chatMenuIconsHandler}><Menu /></LI>
    </UL>
  );
};

export default ChatMenuIcons;
